import * as WidgetQueries from '../../queries/widget';
import { makeApolloClient, logError } from '../util';

export const SET_WIDGETS = 'SET_WIDGETS';
export const CLEAR_WIDGETS = 'CLEAR_WIDGETS';
export const CREATE_WIDGET = 'CREATE_WIDGET';
export const UPDATE_WIDGET = 'UPDATE_WIDGET';
export const DELETE_WIDGET = 'DELETE_WIDGET';

export const setWidgets = (widgets, from) => ({
	type: SET_WIDGETS,
	from,
	widgets,
});

export const clearWidgets = from => ({
	type: CLEAR_WIDGETS,
	from,
});

export const createWidget = (widget, index, from) => ({
	type: CREATE_WIDGET,
	widget,
	index,
	from,
});

export const updateWidget = (widget, from) => ({
	type: UPDATE_WIDGET,
	widget,
	from,
});

export const deleteWidget = (widgetID, from) => ({
	type: DELETE_WIDGET,
	widgetID,
	from,
});

export const thunkFetchHomescreenWidgets = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventWidgets } = await client.request(WidgetQueries.EVENT_WIDGETS, {
			event_id: eventID,
		});
		dispatch(setWidgets(eventWidgets, from));
	} catch (error) {
		logError(error, 'widget.actions.thunkFetchHomescreenWidgets');
	}
};
